// source: stories/v1/story.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.stories.v1.Comment', null, global);
goog.exportSymbol('proto.stories.v1.CreateCommentRequest', null, global);
goog.exportSymbol('proto.stories.v1.CreateMonthlyThemeRequest', null, global);
goog.exportSymbol('proto.stories.v1.CreateStoryRequest', null, global);
goog.exportSymbol('proto.stories.v1.DeleteCommentRequest', null, global);
goog.exportSymbol('proto.stories.v1.DeleteStoryRequest', null, global);
goog.exportSymbol('proto.stories.v1.EventLanguage', null, global);
goog.exportSymbol('proto.stories.v1.EventSummary', null, global);
goog.exportSymbol('proto.stories.v1.GetHomeRequest', null, global);
goog.exportSymbol('proto.stories.v1.GetHomeResponse', null, global);
goog.exportSymbol('proto.stories.v1.GetStoryRequest', null, global);
goog.exportSymbol('proto.stories.v1.GetStoryRequest.IdentifierCase', null, global);
goog.exportSymbol('proto.stories.v1.HideCommentRequest', null, global);
goog.exportSymbol('proto.stories.v1.HomeContent', null, global);
goog.exportSymbol('proto.stories.v1.ListCommentsRequest', null, global);
goog.exportSymbol('proto.stories.v1.ListCommentsResponse', null, global);
goog.exportSymbol('proto.stories.v1.ListMonthlyThemesRequest', null, global);
goog.exportSymbol('proto.stories.v1.ListMonthlyThemesResponse', null, global);
goog.exportSymbol('proto.stories.v1.ListStoriesByMonthRequest', null, global);
goog.exportSymbol('proto.stories.v1.ListStoriesByMonthResponse', null, global);
goog.exportSymbol('proto.stories.v1.ListStoriesRequest', null, global);
goog.exportSymbol('proto.stories.v1.ListStoriesResponse', null, global);
goog.exportSymbol('proto.stories.v1.ListTagsRequest', null, global);
goog.exportSymbol('proto.stories.v1.ListTagsResponse', null, global);
goog.exportSymbol('proto.stories.v1.MonthlyStorySection', null, global);
goog.exportSymbol('proto.stories.v1.MonthlyTheme', null, global);
goog.exportSymbol('proto.stories.v1.ReplyToCommentRequest', null, global);
goog.exportSymbol('proto.stories.v1.ResourceType', null, global);
goog.exportSymbol('proto.stories.v1.Story', null, global);
goog.exportSymbol('proto.stories.v1.StoryResource', null, global);
goog.exportSymbol('proto.stories.v1.UpdateMonthlyThemeRequest', null, global);
goog.exportSymbol('proto.stories.v1.UpdateStoryRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.Story = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.Story.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.Story, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.Story.displayName = 'proto.stories.v1.Story';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.StoryResource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.StoryResource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.StoryResource.displayName = 'proto.stories.v1.StoryResource';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.MonthlyTheme = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.MonthlyTheme.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.MonthlyTheme, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.MonthlyTheme.displayName = 'proto.stories.v1.MonthlyTheme';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.HomeContent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.HomeContent.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.HomeContent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.HomeContent.displayName = 'proto.stories.v1.HomeContent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.MonthlyStorySection = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.MonthlyStorySection.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.MonthlyStorySection, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.MonthlyStorySection.displayName = 'proto.stories.v1.MonthlyStorySection';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.EventSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.EventSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.EventSummary.displayName = 'proto.stories.v1.EventSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListStoriesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.ListStoriesRequest.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.ListStoriesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListStoriesRequest.displayName = 'proto.stories.v1.ListStoriesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListStoriesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.ListStoriesResponse.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.ListStoriesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListStoriesResponse.displayName = 'proto.stories.v1.ListStoriesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.GetStoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.stories.v1.GetStoryRequest.oneofGroups_);
};
goog.inherits(proto.stories.v1.GetStoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.GetStoryRequest.displayName = 'proto.stories.v1.GetStoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListStoriesByMonthRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.ListStoriesByMonthRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListStoriesByMonthRequest.displayName = 'proto.stories.v1.ListStoriesByMonthRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListStoriesByMonthResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.ListStoriesByMonthResponse.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.ListStoriesByMonthResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListStoriesByMonthResponse.displayName = 'proto.stories.v1.ListStoriesByMonthResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListMonthlyThemesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.ListMonthlyThemesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListMonthlyThemesRequest.displayName = 'proto.stories.v1.ListMonthlyThemesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListMonthlyThemesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.ListMonthlyThemesResponse.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.ListMonthlyThemesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListMonthlyThemesResponse.displayName = 'proto.stories.v1.ListMonthlyThemesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListTagsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.ListTagsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListTagsRequest.displayName = 'proto.stories.v1.ListTagsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListTagsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.ListTagsResponse.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.ListTagsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListTagsResponse.displayName = 'proto.stories.v1.ListTagsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.GetHomeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.GetHomeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.GetHomeRequest.displayName = 'proto.stories.v1.GetHomeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.GetHomeResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.GetHomeResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.GetHomeResponse.displayName = 'proto.stories.v1.GetHomeResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.CreateStoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.CreateStoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.CreateStoryRequest.displayName = 'proto.stories.v1.CreateStoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.UpdateStoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.UpdateStoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.UpdateStoryRequest.displayName = 'proto.stories.v1.UpdateStoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.DeleteStoryRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.DeleteStoryRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.DeleteStoryRequest.displayName = 'proto.stories.v1.DeleteStoryRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.CreateMonthlyThemeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.CreateMonthlyThemeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.CreateMonthlyThemeRequest.displayName = 'proto.stories.v1.CreateMonthlyThemeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.UpdateMonthlyThemeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.UpdateMonthlyThemeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.UpdateMonthlyThemeRequest.displayName = 'proto.stories.v1.UpdateMonthlyThemeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.Comment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.Comment.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.Comment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.Comment.displayName = 'proto.stories.v1.Comment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListCommentsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.ListCommentsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListCommentsRequest.displayName = 'proto.stories.v1.ListCommentsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ListCommentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.stories.v1.ListCommentsResponse.repeatedFields_, null);
};
goog.inherits(proto.stories.v1.ListCommentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ListCommentsResponse.displayName = 'proto.stories.v1.ListCommentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.CreateCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.CreateCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.CreateCommentRequest.displayName = 'proto.stories.v1.CreateCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.DeleteCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.DeleteCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.DeleteCommentRequest.displayName = 'proto.stories.v1.DeleteCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.HideCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.HideCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.HideCommentRequest.displayName = 'proto.stories.v1.HideCommentRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.stories.v1.ReplyToCommentRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.stories.v1.ReplyToCommentRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.stories.v1.ReplyToCommentRequest.displayName = 'proto.stories.v1.ReplyToCommentRequest';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.Story.repeatedFields_ = [9,10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.Story.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.Story.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.Story} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.Story.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
slug: jspb.Message.getFieldWithDefault(msg, 2, ""),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
description: jspb.Message.getFieldWithDefault(msg, 4, ""),
coverImageUrl: jspb.Message.getFieldWithDefault(msg, 5, ""),
monthId: jspb.Message.getFieldWithDefault(msg, 6, ""),
monthNumber: jspb.Message.getFieldWithDefault(msg, 7, 0),
monthTitle: jspb.Message.getFieldWithDefault(msg, 8, ""),
coreWordsList: (f = jspb.Message.getRepeatedField(msg, 9)) == null ? undefined : f,
tagsList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
resourcesList: jspb.Message.toObjectList(msg.getResourcesList(),
    proto.stories.v1.StoryResource.toObject, includeInstance),
publishedAt: (f = msg.getPublishedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.Story}
 */
proto.stories.v1.Story.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.Story;
  return proto.stories.v1.Story.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.Story} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.Story}
 */
proto.stories.v1.Story.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCoverImageUrl(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonthId(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthNumber(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonthTitle(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.addCoreWords(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 11:
      var value = new proto.stories.v1.StoryResource;
      reader.readMessage(value,proto.stories.v1.StoryResource.deserializeBinaryFromReader);
      msg.addResources(value);
      break;
    case 12:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPublishedAt(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.Story.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.Story.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.Story} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.Story.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSlug();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCoverImageUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMonthId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getMonthNumber();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getMonthTitle();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCoreWordsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      9,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      10,
      f
    );
  }
  f = message.getResourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.stories.v1.StoryResource.serializeBinaryToWriter
    );
  }
  f = message.getPublishedAt();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.stories.v1.Story.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string slug = 2;
 * @return {string}
 */
proto.stories.v1.Story.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setSlug = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.stories.v1.Story.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.stories.v1.Story.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string cover_image_url = 5;
 * @return {string}
 */
proto.stories.v1.Story.prototype.getCoverImageUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setCoverImageUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string month_id = 6;
 * @return {string}
 */
proto.stories.v1.Story.prototype.getMonthId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setMonthId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 month_number = 7;
 * @return {number}
 */
proto.stories.v1.Story.prototype.getMonthNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setMonthNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string month_title = 8;
 * @return {string}
 */
proto.stories.v1.Story.prototype.getMonthTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setMonthTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated string core_words = 9;
 * @return {!Array<string>}
 */
proto.stories.v1.Story.prototype.getCoreWordsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 9));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setCoreWordsList = function(value) {
  return jspb.Message.setField(this, 9, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.addCoreWords = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 9, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.clearCoreWordsList = function() {
  return this.setCoreWordsList([]);
};


/**
 * repeated string tags = 10;
 * @return {!Array<string>}
 */
proto.stories.v1.Story.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * repeated StoryResource resources = 11;
 * @return {!Array<!proto.stories.v1.StoryResource>}
 */
proto.stories.v1.Story.prototype.getResourcesList = function() {
  return /** @type{!Array<!proto.stories.v1.StoryResource>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stories.v1.StoryResource, 11));
};


/**
 * @param {!Array<!proto.stories.v1.StoryResource>} value
 * @return {!proto.stories.v1.Story} returns this
*/
proto.stories.v1.Story.prototype.setResourcesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.stories.v1.StoryResource=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.StoryResource}
 */
proto.stories.v1.Story.prototype.addResources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.stories.v1.StoryResource, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.clearResourcesList = function() {
  return this.setResourcesList([]);
};


/**
 * optional google.protobuf.Timestamp published_at = 12;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stories.v1.Story.prototype.getPublishedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 12));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stories.v1.Story} returns this
*/
proto.stories.v1.Story.prototype.setPublishedAt = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.clearPublishedAt = function() {
  return this.setPublishedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.Story.prototype.hasPublishedAt = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stories.v1.Story.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stories.v1.Story} returns this
*/
proto.stories.v1.Story.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.Story} returns this
 */
proto.stories.v1.Story.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.Story.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.StoryResource.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.StoryResource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.StoryResource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.StoryResource.toObject = function(includeInstance, msg) {
  var f, obj = {
type: jspb.Message.getFieldWithDefault(msg, 1, 0),
url: jspb.Message.getFieldWithDefault(msg, 2, ""),
available: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.StoryResource}
 */
proto.stories.v1.StoryResource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.StoryResource;
  return proto.stories.v1.StoryResource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.StoryResource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.StoryResource}
 */
proto.stories.v1.StoryResource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.stories.v1.ResourceType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUrl(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAvailable(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.StoryResource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.StoryResource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.StoryResource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.StoryResource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getUrl();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAvailable();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional ResourceType type = 1;
 * @return {!proto.stories.v1.ResourceType}
 */
proto.stories.v1.StoryResource.prototype.getType = function() {
  return /** @type {!proto.stories.v1.ResourceType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.stories.v1.ResourceType} value
 * @return {!proto.stories.v1.StoryResource} returns this
 */
proto.stories.v1.StoryResource.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string url = 2;
 * @return {string}
 */
proto.stories.v1.StoryResource.prototype.getUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.StoryResource} returns this
 */
proto.stories.v1.StoryResource.prototype.setUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional bool available = 3;
 * @return {boolean}
 */
proto.stories.v1.StoryResource.prototype.getAvailable = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stories.v1.StoryResource} returns this
 */
proto.stories.v1.StoryResource.prototype.setAvailable = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.MonthlyTheme.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.MonthlyTheme.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.MonthlyTheme.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.MonthlyTheme} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.MonthlyTheme.toObject = function(includeInstance, msg) {
  var f, obj = {
monthId: jspb.Message.getFieldWithDefault(msg, 1, ""),
monthNumber: jspb.Message.getFieldWithDefault(msg, 2, 0),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
emoji: jspb.Message.getFieldWithDefault(msg, 4, ""),
coreWordsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
description: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.MonthlyTheme}
 */
proto.stories.v1.MonthlyTheme.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.MonthlyTheme;
  return proto.stories.v1.MonthlyTheme.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.MonthlyTheme} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.MonthlyTheme}
 */
proto.stories.v1.MonthlyTheme.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonthId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthNumber(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmoji(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addCoreWords(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.MonthlyTheme.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.MonthlyTheme.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.MonthlyTheme} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.MonthlyTheme.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonthId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMonthNumber();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmoji();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCoreWordsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string month_id = 1;
 * @return {string}
 */
proto.stories.v1.MonthlyTheme.prototype.getMonthId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.MonthlyTheme} returns this
 */
proto.stories.v1.MonthlyTheme.prototype.setMonthId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 month_number = 2;
 * @return {number}
 */
proto.stories.v1.MonthlyTheme.prototype.getMonthNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.MonthlyTheme} returns this
 */
proto.stories.v1.MonthlyTheme.prototype.setMonthNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.stories.v1.MonthlyTheme.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.MonthlyTheme} returns this
 */
proto.stories.v1.MonthlyTheme.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string emoji = 4;
 * @return {string}
 */
proto.stories.v1.MonthlyTheme.prototype.getEmoji = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.MonthlyTheme} returns this
 */
proto.stories.v1.MonthlyTheme.prototype.setEmoji = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * repeated string core_words = 5;
 * @return {!Array<string>}
 */
proto.stories.v1.MonthlyTheme.prototype.getCoreWordsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.stories.v1.MonthlyTheme} returns this
 */
proto.stories.v1.MonthlyTheme.prototype.setCoreWordsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.MonthlyTheme} returns this
 */
proto.stories.v1.MonthlyTheme.prototype.addCoreWords = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.MonthlyTheme} returns this
 */
proto.stories.v1.MonthlyTheme.prototype.clearCoreWordsList = function() {
  return this.setCoreWordsList([]);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.stories.v1.MonthlyTheme.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.MonthlyTheme} returns this
 */
proto.stories.v1.MonthlyTheme.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.HomeContent.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.HomeContent.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.HomeContent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.HomeContent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.HomeContent.toObject = function(includeInstance, msg) {
  var f, obj = {
upcomingEventsList: jspb.Message.toObjectList(msg.getUpcomingEventsList(),
    proto.stories.v1.EventSummary.toObject, includeInstance),
monthlySectionsList: jspb.Message.toObjectList(msg.getMonthlySectionsList(),
    proto.stories.v1.MonthlyStorySection.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.HomeContent}
 */
proto.stories.v1.HomeContent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.HomeContent;
  return proto.stories.v1.HomeContent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.HomeContent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.HomeContent}
 */
proto.stories.v1.HomeContent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.EventSummary;
      reader.readMessage(value,proto.stories.v1.EventSummary.deserializeBinaryFromReader);
      msg.addUpcomingEvents(value);
      break;
    case 2:
      var value = new proto.stories.v1.MonthlyStorySection;
      reader.readMessage(value,proto.stories.v1.MonthlyStorySection.deserializeBinaryFromReader);
      msg.addMonthlySections(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.HomeContent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.HomeContent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.HomeContent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.HomeContent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUpcomingEventsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stories.v1.EventSummary.serializeBinaryToWriter
    );
  }
  f = message.getMonthlySectionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.stories.v1.MonthlyStorySection.serializeBinaryToWriter
    );
  }
};


/**
 * repeated EventSummary upcoming_events = 1;
 * @return {!Array<!proto.stories.v1.EventSummary>}
 */
proto.stories.v1.HomeContent.prototype.getUpcomingEventsList = function() {
  return /** @type{!Array<!proto.stories.v1.EventSummary>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stories.v1.EventSummary, 1));
};


/**
 * @param {!Array<!proto.stories.v1.EventSummary>} value
 * @return {!proto.stories.v1.HomeContent} returns this
*/
proto.stories.v1.HomeContent.prototype.setUpcomingEventsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stories.v1.EventSummary=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.EventSummary}
 */
proto.stories.v1.HomeContent.prototype.addUpcomingEvents = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stories.v1.EventSummary, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.HomeContent} returns this
 */
proto.stories.v1.HomeContent.prototype.clearUpcomingEventsList = function() {
  return this.setUpcomingEventsList([]);
};


/**
 * repeated MonthlyStorySection monthly_sections = 2;
 * @return {!Array<!proto.stories.v1.MonthlyStorySection>}
 */
proto.stories.v1.HomeContent.prototype.getMonthlySectionsList = function() {
  return /** @type{!Array<!proto.stories.v1.MonthlyStorySection>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stories.v1.MonthlyStorySection, 2));
};


/**
 * @param {!Array<!proto.stories.v1.MonthlyStorySection>} value
 * @return {!proto.stories.v1.HomeContent} returns this
*/
proto.stories.v1.HomeContent.prototype.setMonthlySectionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.stories.v1.MonthlyStorySection=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.MonthlyStorySection}
 */
proto.stories.v1.HomeContent.prototype.addMonthlySections = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.stories.v1.MonthlyStorySection, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.HomeContent} returns this
 */
proto.stories.v1.HomeContent.prototype.clearMonthlySectionsList = function() {
  return this.setMonthlySectionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.MonthlyStorySection.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.MonthlyStorySection.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.MonthlyStorySection.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.MonthlyStorySection} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.MonthlyStorySection.toObject = function(includeInstance, msg) {
  var f, obj = {
theme: (f = msg.getTheme()) && proto.stories.v1.MonthlyTheme.toObject(includeInstance, f),
storiesList: jspb.Message.toObjectList(msg.getStoriesList(),
    proto.stories.v1.Story.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.MonthlyStorySection}
 */
proto.stories.v1.MonthlyStorySection.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.MonthlyStorySection;
  return proto.stories.v1.MonthlyStorySection.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.MonthlyStorySection} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.MonthlyStorySection}
 */
proto.stories.v1.MonthlyStorySection.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.MonthlyTheme;
      reader.readMessage(value,proto.stories.v1.MonthlyTheme.deserializeBinaryFromReader);
      msg.setTheme(value);
      break;
    case 2:
      var value = new proto.stories.v1.Story;
      reader.readMessage(value,proto.stories.v1.Story.deserializeBinaryFromReader);
      msg.addStories(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.MonthlyStorySection.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.MonthlyStorySection.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.MonthlyStorySection} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.MonthlyStorySection.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTheme();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stories.v1.MonthlyTheme.serializeBinaryToWriter
    );
  }
  f = message.getStoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.stories.v1.Story.serializeBinaryToWriter
    );
  }
};


/**
 * optional MonthlyTheme theme = 1;
 * @return {?proto.stories.v1.MonthlyTheme}
 */
proto.stories.v1.MonthlyStorySection.prototype.getTheme = function() {
  return /** @type{?proto.stories.v1.MonthlyTheme} */ (
    jspb.Message.getWrapperField(this, proto.stories.v1.MonthlyTheme, 1));
};


/**
 * @param {?proto.stories.v1.MonthlyTheme|undefined} value
 * @return {!proto.stories.v1.MonthlyStorySection} returns this
*/
proto.stories.v1.MonthlyStorySection.prototype.setTheme = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.MonthlyStorySection} returns this
 */
proto.stories.v1.MonthlyStorySection.prototype.clearTheme = function() {
  return this.setTheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.MonthlyStorySection.prototype.hasTheme = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Story stories = 2;
 * @return {!Array<!proto.stories.v1.Story>}
 */
proto.stories.v1.MonthlyStorySection.prototype.getStoriesList = function() {
  return /** @type{!Array<!proto.stories.v1.Story>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stories.v1.Story, 2));
};


/**
 * @param {!Array<!proto.stories.v1.Story>} value
 * @return {!proto.stories.v1.MonthlyStorySection} returns this
*/
proto.stories.v1.MonthlyStorySection.prototype.setStoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.stories.v1.Story=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.Story}
 */
proto.stories.v1.MonthlyStorySection.prototype.addStories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.stories.v1.Story, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.MonthlyStorySection} returns this
 */
proto.stories.v1.MonthlyStorySection.prototype.clearStoriesList = function() {
  return this.setStoriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.EventSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.EventSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.EventSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.EventSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
title: jspb.Message.getFieldWithDefault(msg, 2, ""),
startTime: (f = msg.getStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
locationName: jspb.Message.getFieldWithDefault(msg, 4, ""),
language: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.EventSummary}
 */
proto.stories.v1.EventSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.EventSummary;
  return proto.stories.v1.EventSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.EventSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.EventSummary}
 */
proto.stories.v1.EventSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartTime(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLocationName(value);
      break;
    case 5:
      var value = /** @type {!proto.stories.v1.EventLanguage} */ (reader.readEnum());
      msg.setLanguage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.EventSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.EventSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.EventSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.EventSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getLocationName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getLanguage();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.stories.v1.EventSummary.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.EventSummary} returns this
 */
proto.stories.v1.EventSummary.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string title = 2;
 * @return {string}
 */
proto.stories.v1.EventSummary.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.EventSummary} returns this
 */
proto.stories.v1.EventSummary.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp start_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stories.v1.EventSummary.prototype.getStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stories.v1.EventSummary} returns this
*/
proto.stories.v1.EventSummary.prototype.setStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.EventSummary} returns this
 */
proto.stories.v1.EventSummary.prototype.clearStartTime = function() {
  return this.setStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.EventSummary.prototype.hasStartTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string location_name = 4;
 * @return {string}
 */
proto.stories.v1.EventSummary.prototype.getLocationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.EventSummary} returns this
 */
proto.stories.v1.EventSummary.prototype.setLocationName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional EventLanguage language = 5;
 * @return {!proto.stories.v1.EventLanguage}
 */
proto.stories.v1.EventSummary.prototype.getLanguage = function() {
  return /** @type {!proto.stories.v1.EventLanguage} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.stories.v1.EventLanguage} value
 * @return {!proto.stories.v1.EventSummary} returns this
 */
proto.stories.v1.EventSummary.prototype.setLanguage = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.ListStoriesRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListStoriesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListStoriesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListStoriesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListStoriesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
keyword: jspb.Message.getFieldWithDefault(msg, 1, ""),
monthId: jspb.Message.getFieldWithDefault(msg, 2, ""),
tagsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f,
page: jspb.Message.getFieldWithDefault(msg, 4, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListStoriesRequest}
 */
proto.stories.v1.ListStoriesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListStoriesRequest;
  return proto.stories.v1.ListStoriesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListStoriesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListStoriesRequest}
 */
proto.stories.v1.ListStoriesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonthId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListStoriesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListStoriesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListStoriesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListStoriesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getMonthId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * optional string keyword = 1;
 * @return {string}
 */
proto.stories.v1.ListStoriesRequest.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.ListStoriesRequest} returns this
 */
proto.stories.v1.ListStoriesRequest.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string month_id = 2;
 * @return {string}
 */
proto.stories.v1.ListStoriesRequest.prototype.getMonthId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.ListStoriesRequest} returns this
 */
proto.stories.v1.ListStoriesRequest.prototype.setMonthId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string tags = 3;
 * @return {!Array<string>}
 */
proto.stories.v1.ListStoriesRequest.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.stories.v1.ListStoriesRequest} returns this
 */
proto.stories.v1.ListStoriesRequest.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.ListStoriesRequest} returns this
 */
proto.stories.v1.ListStoriesRequest.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.ListStoriesRequest} returns this
 */
proto.stories.v1.ListStoriesRequest.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};


/**
 * optional int32 page = 4;
 * @return {number}
 */
proto.stories.v1.ListStoriesRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesRequest} returns this
 */
proto.stories.v1.ListStoriesRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 page_size = 5;
 * @return {number}
 */
proto.stories.v1.ListStoriesRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesRequest} returns this
 */
proto.stories.v1.ListStoriesRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.ListStoriesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListStoriesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListStoriesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListStoriesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListStoriesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
storiesList: jspb.Message.toObjectList(msg.getStoriesList(),
    proto.stories.v1.Story.toObject, includeInstance),
total: jspb.Message.getFieldWithDefault(msg, 2, 0),
page: jspb.Message.getFieldWithDefault(msg, 3, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 4, 0),
totalPages: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListStoriesResponse}
 */
proto.stories.v1.ListStoriesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListStoriesResponse;
  return proto.stories.v1.ListStoriesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListStoriesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListStoriesResponse}
 */
proto.stories.v1.ListStoriesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.Story;
      reader.readMessage(value,proto.stories.v1.Story.deserializeBinaryFromReader);
      msg.addStories(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListStoriesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListStoriesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListStoriesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListStoriesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stories.v1.Story.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getTotalPages();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
};


/**
 * repeated Story stories = 1;
 * @return {!Array<!proto.stories.v1.Story>}
 */
proto.stories.v1.ListStoriesResponse.prototype.getStoriesList = function() {
  return /** @type{!Array<!proto.stories.v1.Story>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stories.v1.Story, 1));
};


/**
 * @param {!Array<!proto.stories.v1.Story>} value
 * @return {!proto.stories.v1.ListStoriesResponse} returns this
*/
proto.stories.v1.ListStoriesResponse.prototype.setStoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stories.v1.Story=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.Story}
 */
proto.stories.v1.ListStoriesResponse.prototype.addStories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stories.v1.Story, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.ListStoriesResponse} returns this
 */
proto.stories.v1.ListStoriesResponse.prototype.clearStoriesList = function() {
  return this.setStoriesList([]);
};


/**
 * optional int32 total = 2;
 * @return {number}
 */
proto.stories.v1.ListStoriesResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesResponse} returns this
 */
proto.stories.v1.ListStoriesResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page = 3;
 * @return {number}
 */
proto.stories.v1.ListStoriesResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesResponse} returns this
 */
proto.stories.v1.ListStoriesResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 page_size = 4;
 * @return {number}
 */
proto.stories.v1.ListStoriesResponse.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesResponse} returns this
 */
proto.stories.v1.ListStoriesResponse.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 total_pages = 5;
 * @return {number}
 */
proto.stories.v1.ListStoriesResponse.prototype.getTotalPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesResponse} returns this
 */
proto.stories.v1.ListStoriesResponse.prototype.setTotalPages = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};



/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.stories.v1.GetStoryRequest.oneofGroups_ = [[1,2]];

/**
 * @enum {number}
 */
proto.stories.v1.GetStoryRequest.IdentifierCase = {
  IDENTIFIER_NOT_SET: 0,
  ID: 1,
  SLUG: 2
};

/**
 * @return {proto.stories.v1.GetStoryRequest.IdentifierCase}
 */
proto.stories.v1.GetStoryRequest.prototype.getIdentifierCase = function() {
  return /** @type {proto.stories.v1.GetStoryRequest.IdentifierCase} */(jspb.Message.computeOneofCase(this, proto.stories.v1.GetStoryRequest.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.GetStoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.GetStoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.GetStoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.GetStoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: (f = jspb.Message.getField(msg, 1)) == null ? undefined : f,
slug: (f = jspb.Message.getField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.GetStoryRequest}
 */
proto.stories.v1.GetStoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.GetStoryRequest;
  return proto.stories.v1.GetStoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.GetStoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.GetStoryRequest}
 */
proto.stories.v1.GetStoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSlug(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.GetStoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.GetStoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.GetStoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.GetStoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {string} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.stories.v1.GetStoryRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.GetStoryRequest} returns this
 */
proto.stories.v1.GetStoryRequest.prototype.setId = function(value) {
  return jspb.Message.setOneofField(this, 1, proto.stories.v1.GetStoryRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.stories.v1.GetStoryRequest} returns this
 */
proto.stories.v1.GetStoryRequest.prototype.clearId = function() {
  return jspb.Message.setOneofField(this, 1, proto.stories.v1.GetStoryRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.GetStoryRequest.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional string slug = 2;
 * @return {string}
 */
proto.stories.v1.GetStoryRequest.prototype.getSlug = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.GetStoryRequest} returns this
 */
proto.stories.v1.GetStoryRequest.prototype.setSlug = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.stories.v1.GetStoryRequest.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.stories.v1.GetStoryRequest} returns this
 */
proto.stories.v1.GetStoryRequest.prototype.clearSlug = function() {
  return jspb.Message.setOneofField(this, 2, proto.stories.v1.GetStoryRequest.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.GetStoryRequest.prototype.hasSlug = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListStoriesByMonthRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListStoriesByMonthRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListStoriesByMonthRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListStoriesByMonthRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
monthId: jspb.Message.getFieldWithDefault(msg, 1, ""),
page: jspb.Message.getFieldWithDefault(msg, 2, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListStoriesByMonthRequest}
 */
proto.stories.v1.ListStoriesByMonthRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListStoriesByMonthRequest;
  return proto.stories.v1.ListStoriesByMonthRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListStoriesByMonthRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListStoriesByMonthRequest}
 */
proto.stories.v1.ListStoriesByMonthRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMonthId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListStoriesByMonthRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListStoriesByMonthRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListStoriesByMonthRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListStoriesByMonthRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMonthId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string month_id = 1;
 * @return {string}
 */
proto.stories.v1.ListStoriesByMonthRequest.prototype.getMonthId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.ListStoriesByMonthRequest} returns this
 */
proto.stories.v1.ListStoriesByMonthRequest.prototype.setMonthId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 page = 2;
 * @return {number}
 */
proto.stories.v1.ListStoriesByMonthRequest.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesByMonthRequest} returns this
 */
proto.stories.v1.ListStoriesByMonthRequest.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_size = 3;
 * @return {number}
 */
proto.stories.v1.ListStoriesByMonthRequest.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesByMonthRequest} returns this
 */
proto.stories.v1.ListStoriesByMonthRequest.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.ListStoriesByMonthResponse.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListStoriesByMonthResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListStoriesByMonthResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListStoriesByMonthResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
theme: (f = msg.getTheme()) && proto.stories.v1.MonthlyTheme.toObject(includeInstance, f),
storiesList: jspb.Message.toObjectList(msg.getStoriesList(),
    proto.stories.v1.Story.toObject, includeInstance),
total: jspb.Message.getFieldWithDefault(msg, 3, 0),
page: jspb.Message.getFieldWithDefault(msg, 4, 0),
pageSize: jspb.Message.getFieldWithDefault(msg, 5, 0),
totalPages: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListStoriesByMonthResponse}
 */
proto.stories.v1.ListStoriesByMonthResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListStoriesByMonthResponse;
  return proto.stories.v1.ListStoriesByMonthResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListStoriesByMonthResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListStoriesByMonthResponse}
 */
proto.stories.v1.ListStoriesByMonthResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.MonthlyTheme;
      reader.readMessage(value,proto.stories.v1.MonthlyTheme.deserializeBinaryFromReader);
      msg.setTheme(value);
      break;
    case 2:
      var value = new proto.stories.v1.Story;
      reader.readMessage(value,proto.stories.v1.Story.deserializeBinaryFromReader);
      msg.addStories(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageSize(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setTotalPages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListStoriesByMonthResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListStoriesByMonthResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListStoriesByMonthResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTheme();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stories.v1.MonthlyTheme.serializeBinaryToWriter
    );
  }
  f = message.getStoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.stories.v1.Story.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getPage();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getPageSize();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getTotalPages();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
};


/**
 * optional MonthlyTheme theme = 1;
 * @return {?proto.stories.v1.MonthlyTheme}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.getTheme = function() {
  return /** @type{?proto.stories.v1.MonthlyTheme} */ (
    jspb.Message.getWrapperField(this, proto.stories.v1.MonthlyTheme, 1));
};


/**
 * @param {?proto.stories.v1.MonthlyTheme|undefined} value
 * @return {!proto.stories.v1.ListStoriesByMonthResponse} returns this
*/
proto.stories.v1.ListStoriesByMonthResponse.prototype.setTheme = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.ListStoriesByMonthResponse} returns this
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.clearTheme = function() {
  return this.setTheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.hasTheme = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * repeated Story stories = 2;
 * @return {!Array<!proto.stories.v1.Story>}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.getStoriesList = function() {
  return /** @type{!Array<!proto.stories.v1.Story>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stories.v1.Story, 2));
};


/**
 * @param {!Array<!proto.stories.v1.Story>} value
 * @return {!proto.stories.v1.ListStoriesByMonthResponse} returns this
*/
proto.stories.v1.ListStoriesByMonthResponse.prototype.setStoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.stories.v1.Story=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.Story}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.addStories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.stories.v1.Story, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.ListStoriesByMonthResponse} returns this
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.clearStoriesList = function() {
  return this.setStoriesList([]);
};


/**
 * optional int32 total = 3;
 * @return {number}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesByMonthResponse} returns this
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 page = 4;
 * @return {number}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.getPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesByMonthResponse} returns this
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.setPage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 page_size = 5;
 * @return {number}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.getPageSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesByMonthResponse} returns this
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.setPageSize = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 total_pages = 6;
 * @return {number}
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.getTotalPages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.ListStoriesByMonthResponse} returns this
 */
proto.stories.v1.ListStoriesByMonthResponse.prototype.setTotalPages = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListMonthlyThemesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListMonthlyThemesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListMonthlyThemesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListMonthlyThemesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListMonthlyThemesRequest}
 */
proto.stories.v1.ListMonthlyThemesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListMonthlyThemesRequest;
  return proto.stories.v1.ListMonthlyThemesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListMonthlyThemesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListMonthlyThemesRequest}
 */
proto.stories.v1.ListMonthlyThemesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListMonthlyThemesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListMonthlyThemesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListMonthlyThemesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListMonthlyThemesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.ListMonthlyThemesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListMonthlyThemesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListMonthlyThemesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListMonthlyThemesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListMonthlyThemesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
themesList: jspb.Message.toObjectList(msg.getThemesList(),
    proto.stories.v1.MonthlyTheme.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListMonthlyThemesResponse}
 */
proto.stories.v1.ListMonthlyThemesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListMonthlyThemesResponse;
  return proto.stories.v1.ListMonthlyThemesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListMonthlyThemesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListMonthlyThemesResponse}
 */
proto.stories.v1.ListMonthlyThemesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.MonthlyTheme;
      reader.readMessage(value,proto.stories.v1.MonthlyTheme.deserializeBinaryFromReader);
      msg.addThemes(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListMonthlyThemesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListMonthlyThemesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListMonthlyThemesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListMonthlyThemesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getThemesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stories.v1.MonthlyTheme.serializeBinaryToWriter
    );
  }
};


/**
 * repeated MonthlyTheme themes = 1;
 * @return {!Array<!proto.stories.v1.MonthlyTheme>}
 */
proto.stories.v1.ListMonthlyThemesResponse.prototype.getThemesList = function() {
  return /** @type{!Array<!proto.stories.v1.MonthlyTheme>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stories.v1.MonthlyTheme, 1));
};


/**
 * @param {!Array<!proto.stories.v1.MonthlyTheme>} value
 * @return {!proto.stories.v1.ListMonthlyThemesResponse} returns this
*/
proto.stories.v1.ListMonthlyThemesResponse.prototype.setThemesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stories.v1.MonthlyTheme=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.MonthlyTheme}
 */
proto.stories.v1.ListMonthlyThemesResponse.prototype.addThemes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stories.v1.MonthlyTheme, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.ListMonthlyThemesResponse} returns this
 */
proto.stories.v1.ListMonthlyThemesResponse.prototype.clearThemesList = function() {
  return this.setThemesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListTagsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListTagsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListTagsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListTagsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListTagsRequest}
 */
proto.stories.v1.ListTagsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListTagsRequest;
  return proto.stories.v1.ListTagsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListTagsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListTagsRequest}
 */
proto.stories.v1.ListTagsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListTagsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListTagsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListTagsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListTagsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.ListTagsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListTagsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListTagsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListTagsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListTagsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
tagsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListTagsResponse}
 */
proto.stories.v1.ListTagsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListTagsResponse;
  return proto.stories.v1.ListTagsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListTagsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListTagsResponse}
 */
proto.stories.v1.ListTagsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addTags(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListTagsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListTagsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListTagsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListTagsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTagsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string tags = 1;
 * @return {!Array<string>}
 */
proto.stories.v1.ListTagsResponse.prototype.getTagsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.stories.v1.ListTagsResponse} returns this
 */
proto.stories.v1.ListTagsResponse.prototype.setTagsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.ListTagsResponse} returns this
 */
proto.stories.v1.ListTagsResponse.prototype.addTags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.ListTagsResponse} returns this
 */
proto.stories.v1.ListTagsResponse.prototype.clearTagsList = function() {
  return this.setTagsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.GetHomeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.GetHomeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.GetHomeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.GetHomeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
eventsLimit: jspb.Message.getFieldWithDefault(msg, 1, 0),
monthsLimit: jspb.Message.getFieldWithDefault(msg, 2, 0),
storiesPerMonth: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.GetHomeRequest}
 */
proto.stories.v1.GetHomeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.GetHomeRequest;
  return proto.stories.v1.GetHomeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.GetHomeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.GetHomeRequest}
 */
proto.stories.v1.GetHomeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEventsLimit(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonthsLimit(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setStoriesPerMonth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.GetHomeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.GetHomeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.GetHomeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.GetHomeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventsLimit();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getMonthsLimit();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getStoriesPerMonth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional int32 events_limit = 1;
 * @return {number}
 */
proto.stories.v1.GetHomeRequest.prototype.getEventsLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.GetHomeRequest} returns this
 */
proto.stories.v1.GetHomeRequest.prototype.setEventsLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 months_limit = 2;
 * @return {number}
 */
proto.stories.v1.GetHomeRequest.prototype.getMonthsLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.GetHomeRequest} returns this
 */
proto.stories.v1.GetHomeRequest.prototype.setMonthsLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 stories_per_month = 3;
 * @return {number}
 */
proto.stories.v1.GetHomeRequest.prototype.getStoriesPerMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.stories.v1.GetHomeRequest} returns this
 */
proto.stories.v1.GetHomeRequest.prototype.setStoriesPerMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.GetHomeResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.GetHomeResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.GetHomeResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.GetHomeResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
content: (f = msg.getContent()) && proto.stories.v1.HomeContent.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.GetHomeResponse}
 */
proto.stories.v1.GetHomeResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.GetHomeResponse;
  return proto.stories.v1.GetHomeResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.GetHomeResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.GetHomeResponse}
 */
proto.stories.v1.GetHomeResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.HomeContent;
      reader.readMessage(value,proto.stories.v1.HomeContent.deserializeBinaryFromReader);
      msg.setContent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.GetHomeResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.GetHomeResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.GetHomeResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.GetHomeResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContent();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stories.v1.HomeContent.serializeBinaryToWriter
    );
  }
};


/**
 * optional HomeContent content = 1;
 * @return {?proto.stories.v1.HomeContent}
 */
proto.stories.v1.GetHomeResponse.prototype.getContent = function() {
  return /** @type{?proto.stories.v1.HomeContent} */ (
    jspb.Message.getWrapperField(this, proto.stories.v1.HomeContent, 1));
};


/**
 * @param {?proto.stories.v1.HomeContent|undefined} value
 * @return {!proto.stories.v1.GetHomeResponse} returns this
*/
proto.stories.v1.GetHomeResponse.prototype.setContent = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.GetHomeResponse} returns this
 */
proto.stories.v1.GetHomeResponse.prototype.clearContent = function() {
  return this.setContent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.GetHomeResponse.prototype.hasContent = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.CreateStoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.CreateStoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.CreateStoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.CreateStoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
story: (f = msg.getStory()) && proto.stories.v1.Story.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.CreateStoryRequest}
 */
proto.stories.v1.CreateStoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.CreateStoryRequest;
  return proto.stories.v1.CreateStoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.CreateStoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.CreateStoryRequest}
 */
proto.stories.v1.CreateStoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.Story;
      reader.readMessage(value,proto.stories.v1.Story.deserializeBinaryFromReader);
      msg.setStory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.CreateStoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.CreateStoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.CreateStoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.CreateStoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStory();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stories.v1.Story.serializeBinaryToWriter
    );
  }
};


/**
 * optional Story story = 1;
 * @return {?proto.stories.v1.Story}
 */
proto.stories.v1.CreateStoryRequest.prototype.getStory = function() {
  return /** @type{?proto.stories.v1.Story} */ (
    jspb.Message.getWrapperField(this, proto.stories.v1.Story, 1));
};


/**
 * @param {?proto.stories.v1.Story|undefined} value
 * @return {!proto.stories.v1.CreateStoryRequest} returns this
*/
proto.stories.v1.CreateStoryRequest.prototype.setStory = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.CreateStoryRequest} returns this
 */
proto.stories.v1.CreateStoryRequest.prototype.clearStory = function() {
  return this.setStory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.CreateStoryRequest.prototype.hasStory = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.UpdateStoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.UpdateStoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.UpdateStoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.UpdateStoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
story: (f = msg.getStory()) && proto.stories.v1.Story.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.UpdateStoryRequest}
 */
proto.stories.v1.UpdateStoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.UpdateStoryRequest;
  return proto.stories.v1.UpdateStoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.UpdateStoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.UpdateStoryRequest}
 */
proto.stories.v1.UpdateStoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.Story;
      reader.readMessage(value,proto.stories.v1.Story.deserializeBinaryFromReader);
      msg.setStory(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.UpdateStoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.UpdateStoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.UpdateStoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.UpdateStoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStory();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stories.v1.Story.serializeBinaryToWriter
    );
  }
};


/**
 * optional Story story = 1;
 * @return {?proto.stories.v1.Story}
 */
proto.stories.v1.UpdateStoryRequest.prototype.getStory = function() {
  return /** @type{?proto.stories.v1.Story} */ (
    jspb.Message.getWrapperField(this, proto.stories.v1.Story, 1));
};


/**
 * @param {?proto.stories.v1.Story|undefined} value
 * @return {!proto.stories.v1.UpdateStoryRequest} returns this
*/
proto.stories.v1.UpdateStoryRequest.prototype.setStory = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.UpdateStoryRequest} returns this
 */
proto.stories.v1.UpdateStoryRequest.prototype.clearStory = function() {
  return this.setStory(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.UpdateStoryRequest.prototype.hasStory = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.DeleteStoryRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.DeleteStoryRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.DeleteStoryRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.DeleteStoryRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.DeleteStoryRequest}
 */
proto.stories.v1.DeleteStoryRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.DeleteStoryRequest;
  return proto.stories.v1.DeleteStoryRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.DeleteStoryRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.DeleteStoryRequest}
 */
proto.stories.v1.DeleteStoryRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.DeleteStoryRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.DeleteStoryRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.DeleteStoryRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.DeleteStoryRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.stories.v1.DeleteStoryRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.DeleteStoryRequest} returns this
 */
proto.stories.v1.DeleteStoryRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.CreateMonthlyThemeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.CreateMonthlyThemeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.CreateMonthlyThemeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.CreateMonthlyThemeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
theme: (f = msg.getTheme()) && proto.stories.v1.MonthlyTheme.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.CreateMonthlyThemeRequest}
 */
proto.stories.v1.CreateMonthlyThemeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.CreateMonthlyThemeRequest;
  return proto.stories.v1.CreateMonthlyThemeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.CreateMonthlyThemeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.CreateMonthlyThemeRequest}
 */
proto.stories.v1.CreateMonthlyThemeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.MonthlyTheme;
      reader.readMessage(value,proto.stories.v1.MonthlyTheme.deserializeBinaryFromReader);
      msg.setTheme(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.CreateMonthlyThemeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.CreateMonthlyThemeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.CreateMonthlyThemeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.CreateMonthlyThemeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTheme();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stories.v1.MonthlyTheme.serializeBinaryToWriter
    );
  }
};


/**
 * optional MonthlyTheme theme = 1;
 * @return {?proto.stories.v1.MonthlyTheme}
 */
proto.stories.v1.CreateMonthlyThemeRequest.prototype.getTheme = function() {
  return /** @type{?proto.stories.v1.MonthlyTheme} */ (
    jspb.Message.getWrapperField(this, proto.stories.v1.MonthlyTheme, 1));
};


/**
 * @param {?proto.stories.v1.MonthlyTheme|undefined} value
 * @return {!proto.stories.v1.CreateMonthlyThemeRequest} returns this
*/
proto.stories.v1.CreateMonthlyThemeRequest.prototype.setTheme = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.CreateMonthlyThemeRequest} returns this
 */
proto.stories.v1.CreateMonthlyThemeRequest.prototype.clearTheme = function() {
  return this.setTheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.CreateMonthlyThemeRequest.prototype.hasTheme = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.UpdateMonthlyThemeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.UpdateMonthlyThemeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.UpdateMonthlyThemeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.UpdateMonthlyThemeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
theme: (f = msg.getTheme()) && proto.stories.v1.MonthlyTheme.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.UpdateMonthlyThemeRequest}
 */
proto.stories.v1.UpdateMonthlyThemeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.UpdateMonthlyThemeRequest;
  return proto.stories.v1.UpdateMonthlyThemeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.UpdateMonthlyThemeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.UpdateMonthlyThemeRequest}
 */
proto.stories.v1.UpdateMonthlyThemeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.MonthlyTheme;
      reader.readMessage(value,proto.stories.v1.MonthlyTheme.deserializeBinaryFromReader);
      msg.setTheme(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.UpdateMonthlyThemeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.UpdateMonthlyThemeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.UpdateMonthlyThemeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.UpdateMonthlyThemeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTheme();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.stories.v1.MonthlyTheme.serializeBinaryToWriter
    );
  }
};


/**
 * optional MonthlyTheme theme = 1;
 * @return {?proto.stories.v1.MonthlyTheme}
 */
proto.stories.v1.UpdateMonthlyThemeRequest.prototype.getTheme = function() {
  return /** @type{?proto.stories.v1.MonthlyTheme} */ (
    jspb.Message.getWrapperField(this, proto.stories.v1.MonthlyTheme, 1));
};


/**
 * @param {?proto.stories.v1.MonthlyTheme|undefined} value
 * @return {!proto.stories.v1.UpdateMonthlyThemeRequest} returns this
*/
proto.stories.v1.UpdateMonthlyThemeRequest.prototype.setTheme = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.UpdateMonthlyThemeRequest} returns this
 */
proto.stories.v1.UpdateMonthlyThemeRequest.prototype.clearTheme = function() {
  return this.setTheme(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.UpdateMonthlyThemeRequest.prototype.hasTheme = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.Comment.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.Comment.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.Comment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.Comment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.Comment.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
storyId: jspb.Message.getFieldWithDefault(msg, 2, ""),
authorName: jspb.Message.getFieldWithDefault(msg, 3, ""),
authorEmail: jspb.Message.getFieldWithDefault(msg, 4, ""),
body: jspb.Message.getFieldWithDefault(msg, 5, ""),
createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
hidden: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
parentId: jspb.Message.getFieldWithDefault(msg, 8, ""),
repliesList: jspb.Message.toObjectList(msg.getRepliesList(),
    proto.stories.v1.Comment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.Comment}
 */
proto.stories.v1.Comment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.Comment;
  return proto.stories.v1.Comment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.Comment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.Comment}
 */
proto.stories.v1.Comment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoryId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 6:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    case 9:
      var value = new proto.stories.v1.Comment;
      reader.readMessage(value,proto.stories.v1.Comment.deserializeBinaryFromReader);
      msg.addReplies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.Comment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.Comment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.Comment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.Comment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStoryId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAuthorName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAuthorEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getRepliesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.stories.v1.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.stories.v1.Comment.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Comment} returns this
 */
proto.stories.v1.Comment.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string story_id = 2;
 * @return {string}
 */
proto.stories.v1.Comment.prototype.getStoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Comment} returns this
 */
proto.stories.v1.Comment.prototype.setStoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string author_name = 3;
 * @return {string}
 */
proto.stories.v1.Comment.prototype.getAuthorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Comment} returns this
 */
proto.stories.v1.Comment.prototype.setAuthorName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string author_email = 4;
 * @return {string}
 */
proto.stories.v1.Comment.prototype.getAuthorEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Comment} returns this
 */
proto.stories.v1.Comment.prototype.setAuthorEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string body = 5;
 * @return {string}
 */
proto.stories.v1.Comment.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Comment} returns this
 */
proto.stories.v1.Comment.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 6;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.stories.v1.Comment.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 6));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.stories.v1.Comment} returns this
*/
proto.stories.v1.Comment.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.stories.v1.Comment} returns this
 */
proto.stories.v1.Comment.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.stories.v1.Comment.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional bool hidden = 7;
 * @return {boolean}
 */
proto.stories.v1.Comment.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stories.v1.Comment} returns this
 */
proto.stories.v1.Comment.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional string parent_id = 8;
 * @return {string}
 */
proto.stories.v1.Comment.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.Comment} returns this
 */
proto.stories.v1.Comment.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated Comment replies = 9;
 * @return {!Array<!proto.stories.v1.Comment>}
 */
proto.stories.v1.Comment.prototype.getRepliesList = function() {
  return /** @type{!Array<!proto.stories.v1.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stories.v1.Comment, 9));
};


/**
 * @param {!Array<!proto.stories.v1.Comment>} value
 * @return {!proto.stories.v1.Comment} returns this
*/
proto.stories.v1.Comment.prototype.setRepliesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.stories.v1.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.Comment}
 */
proto.stories.v1.Comment.prototype.addReplies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.stories.v1.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.Comment} returns this
 */
proto.stories.v1.Comment.prototype.clearRepliesList = function() {
  return this.setRepliesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListCommentsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListCommentsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListCommentsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListCommentsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
storyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
includeHidden: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListCommentsRequest}
 */
proto.stories.v1.ListCommentsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListCommentsRequest;
  return proto.stories.v1.ListCommentsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListCommentsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListCommentsRequest}
 */
proto.stories.v1.ListCommentsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoryId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeHidden(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListCommentsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListCommentsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListCommentsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListCommentsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStoryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIncludeHidden();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string story_id = 1;
 * @return {string}
 */
proto.stories.v1.ListCommentsRequest.prototype.getStoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.ListCommentsRequest} returns this
 */
proto.stories.v1.ListCommentsRequest.prototype.setStoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool include_hidden = 2;
 * @return {boolean}
 */
proto.stories.v1.ListCommentsRequest.prototype.getIncludeHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stories.v1.ListCommentsRequest} returns this
 */
proto.stories.v1.ListCommentsRequest.prototype.setIncludeHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.stories.v1.ListCommentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ListCommentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ListCommentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ListCommentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListCommentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
commentsList: jspb.Message.toObjectList(msg.getCommentsList(),
    proto.stories.v1.Comment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ListCommentsResponse}
 */
proto.stories.v1.ListCommentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ListCommentsResponse;
  return proto.stories.v1.ListCommentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ListCommentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ListCommentsResponse}
 */
proto.stories.v1.ListCommentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.stories.v1.Comment;
      reader.readMessage(value,proto.stories.v1.Comment.deserializeBinaryFromReader);
      msg.addComments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ListCommentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ListCommentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ListCommentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ListCommentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCommentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.stories.v1.Comment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Comment comments = 1;
 * @return {!Array<!proto.stories.v1.Comment>}
 */
proto.stories.v1.ListCommentsResponse.prototype.getCommentsList = function() {
  return /** @type{!Array<!proto.stories.v1.Comment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.stories.v1.Comment, 1));
};


/**
 * @param {!Array<!proto.stories.v1.Comment>} value
 * @return {!proto.stories.v1.ListCommentsResponse} returns this
*/
proto.stories.v1.ListCommentsResponse.prototype.setCommentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.stories.v1.Comment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.stories.v1.Comment}
 */
proto.stories.v1.ListCommentsResponse.prototype.addComments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.stories.v1.Comment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.stories.v1.ListCommentsResponse} returns this
 */
proto.stories.v1.ListCommentsResponse.prototype.clearCommentsList = function() {
  return this.setCommentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.CreateCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.CreateCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.CreateCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.CreateCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
storyId: jspb.Message.getFieldWithDefault(msg, 1, ""),
authorName: jspb.Message.getFieldWithDefault(msg, 2, ""),
authorEmail: jspb.Message.getFieldWithDefault(msg, 3, ""),
body: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.CreateCommentRequest}
 */
proto.stories.v1.CreateCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.CreateCommentRequest;
  return proto.stories.v1.CreateCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.CreateCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.CreateCommentRequest}
 */
proto.stories.v1.CreateCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoryId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorEmail(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.CreateCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.CreateCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.CreateCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.CreateCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStoryId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAuthorName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAuthorEmail();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string story_id = 1;
 * @return {string}
 */
proto.stories.v1.CreateCommentRequest.prototype.getStoryId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.CreateCommentRequest} returns this
 */
proto.stories.v1.CreateCommentRequest.prototype.setStoryId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string author_name = 2;
 * @return {string}
 */
proto.stories.v1.CreateCommentRequest.prototype.getAuthorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.CreateCommentRequest} returns this
 */
proto.stories.v1.CreateCommentRequest.prototype.setAuthorName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string author_email = 3;
 * @return {string}
 */
proto.stories.v1.CreateCommentRequest.prototype.getAuthorEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.CreateCommentRequest} returns this
 */
proto.stories.v1.CreateCommentRequest.prototype.setAuthorEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string body = 4;
 * @return {string}
 */
proto.stories.v1.CreateCommentRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.CreateCommentRequest} returns this
 */
proto.stories.v1.CreateCommentRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.DeleteCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.DeleteCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.DeleteCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.DeleteCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.DeleteCommentRequest}
 */
proto.stories.v1.DeleteCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.DeleteCommentRequest;
  return proto.stories.v1.DeleteCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.DeleteCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.DeleteCommentRequest}
 */
proto.stories.v1.DeleteCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.DeleteCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.DeleteCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.DeleteCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.DeleteCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.stories.v1.DeleteCommentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.DeleteCommentRequest} returns this
 */
proto.stories.v1.DeleteCommentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.HideCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.HideCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.HideCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.HideCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
hidden: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.HideCommentRequest}
 */
proto.stories.v1.HideCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.HideCommentRequest;
  return proto.stories.v1.HideCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.HideCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.HideCommentRequest}
 */
proto.stories.v1.HideCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHidden(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.HideCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.HideCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.HideCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.HideCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getHidden();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.stories.v1.HideCommentRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.HideCommentRequest} returns this
 */
proto.stories.v1.HideCommentRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool hidden = 2;
 * @return {boolean}
 */
proto.stories.v1.HideCommentRequest.prototype.getHidden = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.stories.v1.HideCommentRequest} returns this
 */
proto.stories.v1.HideCommentRequest.prototype.setHidden = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.stories.v1.ReplyToCommentRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.stories.v1.ReplyToCommentRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.stories.v1.ReplyToCommentRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ReplyToCommentRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
parentId: jspb.Message.getFieldWithDefault(msg, 1, ""),
body: jspb.Message.getFieldWithDefault(msg, 2, ""),
authorName: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.stories.v1.ReplyToCommentRequest}
 */
proto.stories.v1.ReplyToCommentRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.stories.v1.ReplyToCommentRequest;
  return proto.stories.v1.ReplyToCommentRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.stories.v1.ReplyToCommentRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.stories.v1.ReplyToCommentRequest}
 */
proto.stories.v1.ReplyToCommentRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParentId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setBody(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuthorName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.stories.v1.ReplyToCommentRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.stories.v1.ReplyToCommentRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.stories.v1.ReplyToCommentRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.stories.v1.ReplyToCommentRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParentId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getBody();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAuthorName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string parent_id = 1;
 * @return {string}
 */
proto.stories.v1.ReplyToCommentRequest.prototype.getParentId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.ReplyToCommentRequest} returns this
 */
proto.stories.v1.ReplyToCommentRequest.prototype.setParentId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string body = 2;
 * @return {string}
 */
proto.stories.v1.ReplyToCommentRequest.prototype.getBody = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.ReplyToCommentRequest} returns this
 */
proto.stories.v1.ReplyToCommentRequest.prototype.setBody = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string author_name = 3;
 * @return {string}
 */
proto.stories.v1.ReplyToCommentRequest.prototype.getAuthorName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.stories.v1.ReplyToCommentRequest} returns this
 */
proto.stories.v1.ReplyToCommentRequest.prototype.setAuthorName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.stories.v1.ResourceType = {
  RESOURCE_TYPE_UNSPECIFIED: 0,
  RESOURCE_TYPE_AMAZON_BOOK: 1,
  RESOURCE_TYPE_YOUTUBE_FULL: 2,
  RESOURCE_TYPE_YOUTUBE_SHORTS: 3,
  RESOURCE_TYPE_YOUTUBE_MUSIC: 4,
  RESOURCE_TYPE_AUDIO: 5,
  RESOURCE_TYPE_EBOOK: 6
};

/**
 * @enum {number}
 */
proto.stories.v1.EventLanguage = {
  EVENT_LANGUAGE_UNSPECIFIED: 0,
  EVENT_LANGUAGE_ENGLISH: 1,
  EVENT_LANGUAGE_MANDARIN: 2,
  EVENT_LANGUAGE_BILINGUAL: 3
};

goog.object.extend(exports, proto.stories.v1);
